export default __webpack_public_path__ + "static/media/world-map-indigo.5898b101.png";